module.exports = __webpack_public_path__ + "static/media/graphic.5153640c.svg";